module.exports = __webpack_public_path__ + "img/logo_BC_TiU_trans.0ef05eba.svg";